import Typography from '@mui/material/Typography';
import Loading from 'components/system/Loading';
import Paper from 'components/system/Paper';
import Icon from 'components/system/Icon';
import colors from 'styles/colors';

const UsageMetric = ({
  label, value, isLoading, icon, sx = {}, internal,
}) => (
  <Paper
    sx={{
      height: '230px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      padding: '24px',
      ...sx,
    }}
  >
    {
      isLoading ? <Loading /> : (
        <>
          {icon ? <Icon name={icon} size="40px" color={colors.primary.main} /> : null}
          <Typography
            variant={internal ? 'buttonLarge' : 'h6'}
            sx={{
              color: colors.text.tetriary,
              marginTop: '16px',
              marginBottom: '5px',
            }}
          >
            {label}
          </Typography>
          <Typography
            variant={internal ? 'body1' : 'h5'}
            sx={{ color: colors.text.primary }}
          >
            {value}
          </Typography>
        </>
      )
    }
  </Paper>
);

export default UsageMetric;
